import { render, staticRenderFns } from "./GSTCBaoCaoGanDay.vue?vue&type=template&id=6096f012&scoped=true"
import script from "./GSTCBaoCaoGanDay.vue?vue&type=script&lang=ts"
export * from "./GSTCBaoCaoGanDay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096f012",
  null
  
)

export default component.exports